export interface Page {
  next: string | null;
  previous: string | null;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalObjects: number;
  results: unknown[];
}

// Initial state for any Pinia-backed paginated field. Quasar 2's q-table is
// stricter than Q1: passing `:rows="store.x.results"` where `results` is
// `undefined` crashes `getTBody`/`getGridBody` with `Cannot read properties of
// undefined (reading 'map')`. Default `results: []` (and the other fields)
// satisfies the table on first render before the async fetch resolves.
export function emptyPage<T extends Page>(): T {
  return {
    next: null,
    previous: null,
    currentPage: 0,
    pageSize: 0,
    totalPages: 0,
    totalObjects: 0,
    results: []
  } as unknown as T;
}
